import { Component, OnInit } from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { Categorie } from "../models/Categorie.model";
import { CategorieService } from "../_services/Categorie.service";

@Component({
  selector: "app-categorieUpdate",
  templateUrl: "./categorieUpdate.component.html",
  styleUrls: ["./categorie.component.css"],
})
export class CategorieUpdateComponent implements OnInit {
  vetement: Categorie;

  constructor(
    private vetementservice: CategorieService,
    private route: ActivatedRoute
  ) {}

  public ngOnInit() {
    const comp = this;
    if (!this.route.snapshot.paramMap.get("id")) {
      this.vetement = new Categorie();
    } else {
      this.vetementservice
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: Categorie) => {
          this.vetement = data;
          console.log(data);
        });
    }

    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }
  insertData() {
    if (this.route.snapshot.paramMap.get("id")) {
      this.vetementservice
        .updateData(this.route.snapshot.paramMap.get("id"), this.vetement)
        .subscribe(() => {
          console.log("Update avec succes");
          window.history.back();
        });
    } else {
      this.vetement.id = null;
      this.vetementservice.insertData(this.vetement).subscribe(
        () => {
          window.history.back();
        },
        () => {
          console.log("false");
        }
      );
    }
  }
  precedentPage() {
    window.history.back();
  }
}
